export function data (state) {
    return state.data
}

export function dataDefault(state) {
    return state.dataDefault
}

export function disableForm (state) {
    return state.disableForm
}

export function menus (state) {
    return state.menus
}

export function menusTabela (state) {
    return state.menusTabela
}

export function pagination (state) {
    return state.pagination
}

export function tipoMenu (state) {
    return state.tipoMenu
}

export function enumStatus (state) {
    return state.enumStatus
}
